import { languages } from '../i18n';

export const getTranslationsQuery = (key?: string) => `
  translations${key ? `(where: { key: "${key}" })` : ''} {
    key
    ${languages.map((lang) => `${lang}\n`)}
  }
`;
